export const LABELS = {
  PICKUP: 'Pickup',
  DROPOFF: 'Dropoff',
  BOOKING_ID: 'ID',
  LUGGAGE: 'Luggage',
  YES: 'Yes',
  NO: 'No',
  GENERAL_COMMENTS:'General Comments',
  COMMENTS: 'Comments',
  CALENDAR:'Calendar'
};
